

export default {
	empty: 'Please input',
	fuzhicg: 'Success',
	fuzhicc: 'Error',
	error:{
		notNull: 'Not be NULL',
		notYes: 'Non-compliant'
	},
    login: {
      signUp:'サインアップ',
      title: 'すべてのデジタル資産のためのユニバーサルウォレット。',
      submit: 'ログイン',
      username: '電話番号を入力してください',
      password: 'パスワードを入力してください',
      verifycode:'キャプチャを入力してください',
      forget_password:'パスワードをお忘れですか？',
	  no_account:'持っていない AuWallet アカウント?',
      register:'登録',
      verifycode_tip:'キャプチャを入力してください',
      verifycode_error:'無効なキャプチャ'
    },
    register:{
      title:'登録',
      username:'電話番号',
      get_code:'コードを取得',
      verifycode:'検証コード',
      password:'パスワード',
      repeat:'確認',
      invite_code:'招待コード',
      submit:'登録',
      registered:'すでにアカウントを取得しています',
      go_login:'ログインする'
    },
    nologin:{
      cloud_wallet:'クラウドウォレット',
      cloud1:'最高のセキュリティ保護',
      cloud2:'ユニークな資産獲得、収入を楽しむためのコインの登録と預け入れ',
      cloud3:'30以上のメインストリームコインと500以上のトークンをサポート',
      button1:'登録',
      button2:'ログイン',
      button_oauth: '2U.Chatでログイン',
      hd_wallet:'HDウォレット',
      hd1:'秘密鍵の100％制御、より確実な資産',
      hd2:'ニーモニックワードのワンクリックインポート、便利で使いやすい',
      hd3:'30以上のメインストリームコインと500以上のトークンをサポート',
      button3:'登録',
      button4:'ログイン',
      doLogin:"クリックしてログイン",
      welcomeTo:"AuWalletへようこそ",
    },
    forget:{
      title:'パスワードをお忘れですか？',
      phone_number:'電話番号',
      verify_code:'検証コード',
      password:'パスワード',
      repeat:'繰り返してください',
      submit:'確認'
    },
    footer:{
      nav1:'財布',
      nav2:'市場',
      nav3:'資産',
      nav4:'発見する',
      nav5:'私の'
    },
    home:{
      total:'総資産',
      invite:'友達を招待',
      redbag:'赤いパケットを送信する',
      exchange:'交換',
      scan:'スキャン',
      address_book:'住所録',
      notice:'通知',
      setting:'設定',
      view_mnemonic:'ニーモニックを表示',
      backup_mnemonic:'バックアップニーモニック',
      create_wallet:'ウォレットを作成する',
      import_wallet:'ウォレットのインポート', 
      welcome:'いらっしゃいませ',
	  cant9sale: 'KYC must pass level 2 or above and have never participated in a 10% discount event.'
    },
    
    address:{
      new_address:'新しいアドレス',
      name:'名前',
      address:'住所',
      submit:'作成',
	  warning_msg: '注意：この住所ではERC 20トークンしか受け取ることができません。振り替えるときは通路を間違えないように注意してください。'
    },
    swap:{
      title:'フラッシュスワップ',
      pay:'あなたが支払う必要があります ',
      balance:'利用可能残高',
      lock_rate:'この為替レートを固定するには、次の時間内に支払いを完了してください',
      gain:'あなたは得るでしょう',
      input:'金額を入力してください',
      tip:'取得する通貨が空の場合、フラッシュスワップする通貨がないことを意味します',
      submit:'今すぐ交換',
      choose_coin:'この通知を読みました',
	  notice_2ut:'この通知を読みました'
    },
    coin:{
      send:'送信',
      swap:'スワップ',
      receive:'受け取る',
      transactions:'トランザクション',
      type1:'クラウドアウト',
      type2:'クラウドイン',
      type3:'スワップ',
      type4:'金融',
      type7:'HD出力',
      type8:'HDイン',
      type9:'赤いパケットを送信する',
      type10:'赤いパケットを受け入れる',
	  type11:'AuWallet transfer out TimeEx',
	  type12:'TimeEx transfer in AuWallet',
	  type13: 'Chain shopping service fee',
	  type14: '10% Off shopping service fee',
	  type15: 'Withdrawal',
	  type16: 'KYC Certification fees',
      flushing:'フラッシング...',
      loading:'読み込み中...',
      no_records:'記録なし',
      wallet:'財布',
      tx_time:'トランザクション時間',
      tx_id:'ID',
      tx_from:'から',
      tx_to:'に',
      tx_memo:'述べる',
      tx_status1:'失敗した',
      tx_status2:'待っている',
      tx_status3:'成功',
      tx_status4:'保留中',
  
      receive_address:'受信アドレスを入力してください',
      balance:'バランス',
      fee:'手数料',
      send_all:'全て送る',
      gas_fee:'ガス料金',
      slow:'スロー',
      fast:'速い',
      send:'送信',
      tx_password:'支払いパスワードを入力してください',
      tx_remark:'備考（オプション）',
      address_book1:'クラウドアドレスブック',
      address_book2:'HDアドレスブック',
      need_pay_pass:'最初に支払いパスワードを設定してください',
      need_pin:'PINコードを設定するには、パーソナルセンターにアクセスしてください',
  
      
      set_receive_amount:'受け取り金額を設定する',
      receive_amount:'受け取り金額',
      copy_receive_code:'支払いコードをコピーする',
      confirm:'確認',
      cancel:'キャンセル',
      rcv_address:'受信アドレス',
      search:'検索コンテンツを入力してください',
      filter:'フィルター',
      remove:'削除する',
      add:'追加',
  
      filter1:'すべての通貨',
      filter2:'追加した',
      filter3:'追加されません',
      
      notices:'HDウォレットの通知',
      notices2:'クラウドウォレットの通知',
	  only_bitcoin: 'Bitcoinトランザクションのみ',
	  only_eth: 'ETHトランザクションのみ',
	  only_usdt: 'USDT ERC 20トランザクションのみ',
	  only_2ut: '2UT のみ',
	  only_u2u: 'U2U コインのみ',
	  only_2u: '2U ポイントのみ',
	  only_a2u: 'A2U のみ',
	  import: 'Import',
	  info: 'Token overview'
    },
  
    market:{
      title:'市場',
      coin:'資産',
      volume:'音量',
      price:'価格',
      change:'変更（24H）',
    },
  
    discover:{
      title:'発見する',
      popular:'人気',
      all:'全て'
    },
  
    my:{
      title:'私の',
      notice:'通知',
      login:'クリックしてログイン ',
      welcome:'AuWalletへようこそ',
      invite:'招待報酬',
      news:'デイリーエクスプレス',
      contact:'顧客サービス',
      pin_on:'で',
      pin_off:'オフ',
      default_currency:'デフォルト通貨',
      red_green:'見積もりオプション',
      option1:'グリーンアップレッドダウン',
      option2:'赤アップ緑ダウン',
      contract:'役務契約',
      privacy:'プライバシーポリシー',
      help:'ヘルプセンター',
		invite: 'My Invite code',
		onequan: 'My Business Circle',
		copy: 'Copy',
		total: 'Total',
		downloadapp: 'Download mobile APP.',
		download: 'Download',
		waiting: 'Waiting Or Use',
		reenxv: 'GreenX Vcode',
		greenxvet: 'Can use'
    },
    setup:{
      title:'ウォレット設定',
      pay_password:'パスワードを支払う',
      on:'の上',
      off:'オフ',
      google:'Google検証',
      security_level:'セキュリティレベル',
      account_name:'アカウント名',
      logout:'ログアウト',
      register_time:'登録時間',
      level:'レベル',
      modify_pay_password:'支払いパスワードを変更する',
      reset_pay_password:'有料パスワードをリセット',
      reset_tip:'アカウントのセキュリティのために、元の支払いパスワードを入力して本人確認を行ってください',
      forget_pay_password:'支払いパスワードを忘れた',
      set_pay_password:'支払いパスワードを設定する',
      enter_password:'パスワードを入力してください',
      enter_password2:'もう一度入力してください',
      vcode:'検証コード',
      submit:'確認',
      pay_password_wrong:'入力したパスワードが正しくありません',
      fontSize:'フォントサイズ'


    },
    news:{
      title:'デイリーエクスプレス',
      share:'シェア',
      good:'良い',
      bad:'悪い',
    },
    pin:{
      title:'PINコードを設定する',
      desc1:'資産のセキュリティを保護するために、最初にPINコードを設定してください。PINコードはウォレットのロックを解除してコインを送信するために使用されます',
      desc2:'PINコードはローカルパスワードです。適切に保管してください。紛失した場合、復元できません。',
      close:'PINコードをオフにする',
      title2:'PINを確認する',
      tip2_1:'PINコードを忘れましたか？ウォレットをバックアップした後、アプリを再インストールし、ニーモニックフレーズをインポートした後にリセットします'
    },
    google:{
      title:'Google検証',
      tip:'Googleの2段階認証プロセスにより、アカウントに保護のレイヤーを追加できます。ログインまたは取引を行うとき、パスワードを入力するときは、2段階認証の確認コードも必要です',
      help:'Googleの2段階認証の使用方法',
    },
    security:{
      title:'セキュリティレベル',
      title2:'セキュリティレベル',
      tip:'資金の安全のために、コインを引き出す前に、さらにセキュリティ設定と実名情報が必要です。それに応じて、引き出し限度額が増加します。',
      l3title:'ドキュメントタイプを選択',
      l3tip:'証明書の発行国を選択してください',
      c1:'アメリカ',
      c2:'中国本土',
      c3:'中国香港、マカオ、タイワn',
      c4:'韓国',
      c5:'日本',
      c6:'シンガポール',
      c7:'他の',
      nousdt: 'Your USDT balance is less than 3 and cannot undergo KYC authentication.',
    },
    realname:{
      title:'認証情報',
      tip:'AuWalletでは、セキュリティ検証に合格するために政府発行の写真付き身分証明書を提出する必要があります',
      subtitle1:'2Uトークン（2UT）サブスクリプションフォーム',
      country:'国',
      country_hint:'お住まいの国',
      firstname:'ファーストネーム',
      firstname_hint:'あなたの下の名前',
      surname:'姓',
      surname_hint:'あなたの苗字',
      birthdate:'誕生日',
      cert_id:'ID番号 ',
      cert_id_hint:'あなたのID番号',
      id_photo1:'ID正面写真',
      id_photo2:'ID反転写真',
      address:'住所',
      address_hint:'あなたの現在の住居',
      addr_photo:'住所の証明',
      asset_photo:'資産の証明',
      subtitle2:'投資家資格認定',
      tip1:'私は、以下の基準の少なくとも1つを満たし、発行者から適格投資家として認定されていることを確認します（該当する場合は、複数を選択できます）。)',
      tip2:'注（1）：投資ポートフォリオとは、不動産を除く有価証券および現金を指します。',
      tip3:'注（2）：過去3か月間に月次報告書、計算概要などが記載された書類を添付する必要があります',
      invest_exp:'投資経験',
      other_exp:'他の',
      avg_volume:'音量',
      avg_volume_hint:'過去12か月の平均取引量（USD）',
      avg_num:'番号',
      avg_num_hint:'過去12か月の平均トランザクション数',
      exp_year:'投資年数',
      exp_year_hint:'投資経験は何年ですか',
      net_asset:'純資産',
      net_asset_hint:'純資産価値（USD）',
      risk_tolerance:'リスク許容度',
      invest_term:'理想的な投資期間',
      derivative:'デリバティブ',
      signature:'サイン',
      reset:'リセット',
      phone_number:'電話番号',
      submit:'送信',
      option1_1:'配偶者または子供との共同口座に2万米ドル（または同等額）以上の現金および/または有価証券のポートフォリオを持つ個人または富裕層の個人投資家',
      option1_2:'会社またはパートナーシップの投資ポートフォリオが20,000米ドル以上、または総資産が200万米ドル以上',
      option1_3:'富裕層の個人投資家、企業、またはパートナーシップは、De La O RuralBank Inc.に口座を開設し、この評価フォームに署名する時点で20,000米ドル以上を保有しています。',
      option2_1:'証券',
      option2_2:'先物',
      option2_3:'配置',
      option2_4:'その他（具体的にご記入ください）',
      option3_1:'高い',
      option3_2:'真ん中',
      option3_3:'低い',
      option4_1:'3年以上',
      option4_2:'1〜3年',
      option4_3:'1年未満',
      option5_1:'はい',
      option5_2:'番号'
    },
    envelope:{
      title:'赤い封筒',
      owned:'私の封筒',
      amount:'額',
      quantity:'量',
      quantity_hint:'封筒の数量',
      generate:'生む',
      title2:'封筒を送る',
      total:'赤い封筒の合計金額',
      wishes:'願い',
      submit:'支払い',
      enter_pass:'有料パスワードを入力してください',
      choose_path:'配送方法を選択してください',
      view:'赤い封筒の詳細を表示',
      choose_coin:'コインを選ぶ',
      need_pay_password:'最初に有料パスワードを設定してください',
      share:'赤い封筒を友達と共有する',
      title3:'赤い封筒の記録',
      num:'量',
    },
    mnemonic:{
      title:'バックアップウォレットニーモニック',
      tip:'ニーモニックは秘密鍵であり、プロパティを制御するための鍵です。',
      tip1:'1. 12文字で構成されていますので、コピーして安全な場所に保管してください.',
      tip2:'2. 100％はあなたが保持します。一度紛失すると、取得できなくなります。',
      tip3:'3. 通貨を受け取ったりアンインストールしたりする前に、必ずニーモニックフレーズのバックアップを完了してください。.',
      backup:'今すぐバックアップ',
      later:'後でやる',
      tip4:'周りを見てください',
      tip5:'ニーモニックを取得した人は、あなたの資産を取得したことを意味します。周りに人がいないこと、カメラがないことを確認してください.',
      understand:'了解した',     
      title2:'ニーモニックを表示',
      tip6:'ニーモニックフレーズをインポートして他のデバイスでペアリングするか、他のデバイスでAuWalletウォレットを使用してQRコードをスキャンしてペアリングすることができます.',
      tip7:'スクリーンショットを撮らないでください！誰かがあなたのニーモニックフレーズを取得した場合、彼らはあなたの資産を直接取得します！',
      view_code:'暗号化されたQRコードを表示する',
      tip8:'QRコードを暗号化することは、ウォレットが新しいデバイスとペアリングするのを容易にすることです。スクリーンショットを撮って保存しないでください。周りに人がいないことや、カメラが隠れていないことを確認してください。.',
      tip9:'このQRコードはAUウォレットでのみ使用できます。スキャンするとき、対応するニーモニックを正常にインポートするには、インポートするAPPに現在のAPPのPINコードを入力する必要があります.',
  
      title3:'AuWalletニーモニックをコピーしてください',
      tip3_1:'AuWalletニーモニックフレーズは、ウォレットを復元するために使用されます。次の12語を順番に紙にコピーして、安全な場所に保管してください.',
      tip3_2:'スクリーンショットを撮らないでください！誰かがあなたのニーモニックフレーズを取得した場合、彼らはあなたの資産を直接取得します！',
      save:'安全に保存しました',
  
      title4:'AuWalletニーモニックフレーズを確認してください',
      tip4_1:'AuWalletニーモニックワードを正しくコピーするために、シリアル番号に対応するワードを選択してください。',
      finish:'終了',
      next:'次',
      verror:'検証エラー',
  
      title5:'ニーモニックウォレットを復元する',
      tip5_1:'ウォレットに返信するには、以下のフォームにニーモニックワードを入力してください。各ニーモニック単語を入力したら、「スペース」キーを押して次の単語にジャンプします',
      recover:'リカバリを開始します',
      ask:'現在のウォレットを上書きする?',
      tip5_2:"ウォレットをインポートすると、現在のウォレットが上書きされます。まだバックアップしていない場合、現在のウォレットは永久に消えます.",
      tip5_3:'現在のウォレットをバックアップし、上書きすることに同意しました',
      cancel:'キャンセル',
      import:'Continue importing',
      agree:'同意することを選択してください',
      create_success:'正常に作成されました',
      complete:'完全なニーモニックを入力してください',
    },
    invite:{
      title:'私の招待状',
      total:'招待番号',
      invite_num:'登録されている友達の数',
      bonus1:'1レベルの友達',
      every:'一人当たり',
      bonus2:'2-レベルの友達',
      bonus3:'3-レベルの友達',
      deposit:'コインを預けている友達の数',
      list:'招待リスト',
      subtitle1:'登録',
      subtitle2:'保証金',
      no_records:'まだ招待状はありません'
    },
    lang:{
      set_lang:'言語を設定する',

    },
    setting:{
      tip:"システムは実際には米ドルで取引され、システムはユーザーの手数料価格を最新の為替レートで米ドルに自動的に変換します。 実際の手数料価格は、ユーザーの入力価格とわずかに異なる場合があります"
    },
    send:{
      title:'転送タイプ',
      t1:'ブロックチェーン転送',
      t2:'内部転送',
    },
    sortable:{
      title:'カスタムソート',
      drag_to_sort:'ドラッグして並べ替え',
      currency:'通貨'
    },
    system:{
      flushing:'フラッシング...',
      loading:'読み込み中...',
      btn1:'確認',
      btn2:'キャンセル',
      add:'追加',
      search:'検索',
      topPullText:'プルダウンして更新',
      topDropText:'リリース更新',
      topLoadingText:'読み込み中...',
      copy_succ:'正常にコピー',
      copy_fail:'コピーに失敗しました',
      about:'About'
    },
    share:{
      title:'シェア',
      download:'コードをスキャンしてダウンロード AuWallet',
      sharecode:'招待コード（クリックしてコピー）:',
      view_invites:'招待状の詳細を表示する',
      copy_link:'リンクをコピーする',
      attention:'上記のリンクをコピーしてモバイルブラウザに貼り付け、開いてAuウォレットをダウンロードします。'
    },
    wealth:{
      tit:"資産",
      title:'私の富',
      title1:'鉱業',
      title2:'コインプラン',
      hot:'人気のおすすめ',
      plan1:'オンデマンドプラン',
      plan2:'固定プラン',
      annu_return:'年換算リターン',
      in_amount:'の金額',
      transfer_all:'全て',
      view_rules:'ルールを表示',
      pay_password:'支払いパスワードを入力してください',
      asset:'富',
      search:'取引のお問い合わせ',
      rules:'ルール',
      order_time:'注文時間',
      value_date:'実行日',
      expiry_date:'有効期限',
      highlights:'ハイライト',
      remaining_quota:'残りのクォータ',
      buy:'今買う',
      ystday_earnings:"昨日の収益",
      total_earnings:'総収入',
      transfer_in:'中に',
      transfer_out:'でる',
	  transfer_outed:'買い戻し済み',
      tran_all:'全て',
      tran_in:'中に',
      tran_out:'でる',
      tran_earning:'収入を得る',
      prod_all:'全て',
      prod1:'PoSマイニング',
      prod2:'コインプラン',
      curr_all:'全て',
      out_amount_tip:'振込金額を入力してください',
      send:'送信',
      success:'成功',
      amount_tip:'金額を入力してください',
    },
    ads:{
      title:'良いたより',
      content:'U2Uがスナップアップされています',
      content2:'2UTがスナップアップされています',
      buy:'買う',
      plan_name:'U2U新株発行',
      tip: 'U2U is 10% off!'
    },
    buyuut: {
      maxtip: 'Each person can buy a maximum of 100',
      current: 'Current',
      price: 'Price',
      discount: 'Discount',
      off: 'OFF',
      amountlabel: 'Purchase quantity',
      maxerror: 'You can\'t buy more than 100',
      totalprice: 'Total Price',
      balance: 'Balance',
      purchase: 'Purchase',
      rulestitle: 'Rules of Activity'
    },
	  receive:{
		  fuzhicg:'コピー成功。',
		  fuzhicc:'コピー失敗。',
	  },
	  alert:{
		  cancel:'キャンセル',
		  confirm:'確認'
	  },
  against:{
		  no100: 'USDTは100の倍数でなければなりません'
	},
	package:{
		  title: 'パッケージ',
		  amount: '量',
		  time: '時間',
		  coin: 'コイン',
		  price: '価格',
		  scale: 'スケール',
		  quantity: '量',
		  submit: '提出する',
		  total: '合計',
		  points: 'ポイント',
		  apoints2: '富の利用可能な利益',
		  balance: 'バランス',
		  apoints: '利用可能ポイント:',
		  abalance: '利用可能残高(USDT):',
		  abalance2: '利用可能残高(U2U):',
		  import: '輸入',
		  orders: '注文',
		  orders_detail: '順序詳細',
		  defi: 'DEFI',
		  nopoint: '利用可能なポイント以上の交換',
		  nobalance: '償還は入手可能残高を超える',
		  nologin: 'ログインが期限切れになった場合は、再度ログインしてください。',
		  pay_type: '賃金タイプ'
	},
	nasdaq:{
		  label :'(IPO)Stock pre purchase application',
		  label2 :'Number of (IPO)stock exchange applications',
		  apply :'Apply',
		  applyed :'Applied',
		  background :'Background Description',
		  text :'1. The formal plan must meet the requirements that the NASDAQ stock reform documents submitted by (relevant stocks) are received and entered into the countdown process for submission.<br />2. During the official review process of NASDAQ (related stocks), there is no rule out the possibility of rejection or extension of time.',
		  cancel: 'Cancel',
		  submit: 'Submit',
	},
	ysjjy: "(Based on actual transactions)"
  }
  